export default {"src":"/_next/static/media/logo.e79d1118.svg","height":100,"width":432,"blurWidth":0,"blurHeight":0};